module.exports = __webpack_public_path__ + "static/media/clover-bg.2140a0d4.jpg";